var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { id: "classCreate" } },
        [
          _c(
            "v-card",
            { attrs: { "max-width": "900px" } },
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
              _vm.editModel
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        { ref: "classForm" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("classEdit.class-name"),
                              required: "",
                              rules: [_vm.rules.required],
                              compact: "",
                              hint: _vm.$t("classEdit.name-hint")
                            },
                            model: {
                              value: _vm.editModel.name,
                              callback: function($$v) {
                                _vm.$set(_vm.editModel, "name", $$v)
                              },
                              expression: "editModel.name"
                            }
                          }),
                          _c(
                            "v-btn",
                            {
                              attrs: { width: "100%", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.lessonPlannerOpen = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("classEdit.lesson-planner")) +
                                  " (" +
                                  _vm._s(_vm.editModel.content.length) +
                                  ") "
                              )
                            ]
                          ),
                          _c(
                            "v-expansion-panels",
                            [
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("classEdit.enrolment-options")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.enrolmentTypes,
                                          compact: "",
                                          "item-text": "title",
                                          "item-value": "uid",
                                          label: _vm.$t(
                                            "classEdit.self-enrolment"
                                          ),
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editModel.enrolmentType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editModel,
                                              "enrolmentType",
                                              $$v
                                            )
                                          },
                                          expression: "editModel.enrolmentType"
                                        }
                                      }),
                                      _vm.editModel.id === undefined &&
                                      _vm.classes
                                        ? _c("v-combobox", {
                                            attrs: {
                                              label: _vm.$t(
                                                "classEdit.copy-members-from"
                                              ),
                                              items: _vm.classes,
                                              "item-text": "name",
                                              "item-value": "id",
                                              clearable: "",
                                              single: "",
                                              "persistent-hint": "",
                                              hint: _vm.$t(
                                                "classEdit.copy-hint"
                                              )
                                            },
                                            model: {
                                              value: _vm.editModel.copyFrom,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editModel,
                                                  "copyFrom",
                                                  $$v
                                                )
                                              },
                                              expression: "editModel.copyFrom"
                                            }
                                          })
                                        : _vm._e(),
                                      _c("br"),
                                      _vm.editModel.enrolmentType === "public"
                                        ? _c("v-combobox", {
                                            attrs: {
                                              "hide-no-data": !_vm.search,
                                              items: _vm.items,
                                              "search-input": _vm.search,
                                              "hide-selected": "",
                                              label: _vm.$t(
                                                "classEdit.restrict-email-domain-to"
                                              ),
                                              hint: _vm.$t(
                                                "classEdit.permittedDomain-hint"
                                              ),
                                              multiple: "",
                                              chips: "",
                                              underline: ""
                                            },
                                            on: {
                                              "update:searchInput": function(
                                                $event
                                              ) {
                                                _vm.search = $event
                                              },
                                              "update:search-input": function(
                                                $event
                                              ) {
                                                _vm.search = $event
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "v-list-item",
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "subheading"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "classEdit.add-domain"
                                                                  )
                                                                ) + " "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              staticClass:
                                                                "chip-class",
                                                              attrs: {
                                                                label: "",
                                                                small: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.search
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var attrs = ref.attrs
                                                    var item = ref.item
                                                    var parent = ref.parent
                                                    var selected = ref.selected
                                                    return [
                                                      item === Object(item)
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  "input-value": selected,
                                                                  label: "",
                                                                  small: ""
                                                                }
                                                              },
                                                              "v-chip",
                                                              attrs,
                                                              false
                                                            ),
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pr-2 chip-class"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.text
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return parent.selectItem(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " $delete "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "item",
                                                  fn: function(ref) {
                                                    var index = ref.index
                                                    var item = ref.item
                                                    return [
                                                      _vm.editing === item
                                                        ? _c("v-text-field", {
                                                            attrs: {
                                                              autofocus: "",
                                                              flat: "",
                                                              "background-color":
                                                                "transparent",
                                                              "hide-details":
                                                                "",
                                                              solo: ""
                                                            },
                                                            on: {
                                                              keyup: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  !$event.type.indexOf(
                                                                    "key"
                                                                  ) &&
                                                                  _vm._k(
                                                                    $event.keyCode,
                                                                    "enter",
                                                                    13,
                                                                    $event.key,
                                                                    "Enter"
                                                                  )
                                                                ) {
                                                                  return null
                                                                }
                                                                return _vm.edit(
                                                                  index,
                                                                  item
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.editing
                                                                  .text,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.editing,
                                                                  "text",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "editing.text"
                                                            }
                                                          })
                                                        : _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                label: "",
                                                                small: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.text
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          ),
                                                      _c("v-spacer"),
                                                      _c(
                                                        "v-list-item-action",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  $event.preventDefault()
                                                                  return _vm.edit(
                                                                    index,
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.editing !==
                                                                      item
                                                                      ? "mdi-pencil"
                                                                      : "mdi-check"
                                                                  )
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              850323738
                                            ),
                                            model: {
                                              value: _vm.temp.permittedDomain,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.temp,
                                                  "permittedDomain",
                                                  $$v
                                                )
                                              },
                                              expression: "temp.permittedDomain"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.editModel.enrolmentType !==
                                      "inviteOnly"
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "classEdit.greeting-text"
                                                      ),
                                                      rows: "3",
                                                      hint: _vm.$t(
                                                        "classEdit.greettext-hint"
                                                      ),
                                                      "persistent-hint": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editModel.greetText,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.editModel,
                                                          "greetText",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editModel.greetText"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.editModel.enrolmentType !==
                                      "inviteOnly"
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      type: "number",
                                                      "single-line": "",
                                                      label: _vm.$t(
                                                        "classEdit.max-class-size"
                                                      ),
                                                      hint: _vm.$t(
                                                        "classEdit.maxsize-hint"
                                                      ),
                                                      "persistent-hint": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editModel.maxSize,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.editModel,
                                                          "maxSize",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editModel.maxSize"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                [
                                                  _c("v-switch", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "classEdit.email-verification-required"
                                                      ),
                                                      inset: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editModel
                                                          .selfEnrolEmailVerification,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.editModel,
                                                          "selfEnrolEmailVerification",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editModel.selfEnrolEmailVerification"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.editModel.enrolmentType !==
                                      "inviteOnly"
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      ref: "menu",
                                                      attrs: {
                                                        "close-on-content-click": false,
                                                        transition:
                                                          "scale-transition",
                                                        "offset-y": "",
                                                        "min-width": "auto"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          label: _vm.$t(
                                                                            "classEdit.enrolment-ends-on"
                                                                          ),
                                                                          hint: _vm.$t(
                                                                            "classEdit.enrolment-end-hint"
                                                                          ),
                                                                          "persistent-hint":
                                                                            "",
                                                                          readonly:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.enrolmentEndDateText,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.enrolmentEndDateText = $$v
                                                                          },
                                                                          expression:
                                                                            "enrolmentEndDateText"
                                                                        }
                                                                      },
                                                                      "v-text-field",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  )
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        4061827246
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.enrolmentMenu,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.enrolmentMenu = $$v
                                                        },
                                                        expression:
                                                          "enrolmentMenu"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-date-picker",
                                                        {
                                                          attrs: {
                                                            "no-title": "",
                                                            scrollable: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.enrolmentEndsDate,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.enrolmentEndsDate = $$v
                                                            },
                                                            expression:
                                                              "enrolmentEndsDate"
                                                          }
                                                        },
                                                        [
                                                          _c("v-spacer"),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.enrolmentMenu = false
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "global.cancel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.saveEnrolmentEndsDate
                                                              }
                                                            },
                                                            [_vm._v(" OK ")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("classEdit.log-in-options")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-switch", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "classEdit.self-register"
                                                  ),
                                                  inset: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.editModel
                                                      .allowSelfRegistration,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editModel,
                                                      "allowSelfRegistration",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editModel.allowSelfRegistration"
                                                }
                                              }),
                                              _c("v-switch", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "classEdit.allow-guests"
                                                  ),
                                                  inset: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.editModel
                                                      .allowGuestJoin,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editModel,
                                                      "allowGuestJoin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editModel.allowGuestJoin"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("classEdit.advanced-options")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "classEdit.additional-admins"
                                                  ),
                                                  items: _vm.editorsOrdered,
                                                  "item-text": "displayName",
                                                  "item-value": "id",
                                                  clearable: "",
                                                  multiple: "",
                                                  "persistent-hint": "",
                                                  chips: "",
                                                  disabled: !_vm.isOwner,
                                                  hint: _vm.editorHint
                                                },
                                                model: {
                                                  value: _vm.editModel.editors,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editModel,
                                                      "editors",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editModel.editors"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "classEdit.class-support-address-label"
                                                  ),
                                                  rules: [_vm.rules.emailRules],
                                                  hint: _vm.$t(
                                                    "classEdit.support-email-hint"
                                                  ),
                                                  "persistent-hint": ""
                                                },
                                                model: {
                                                  value: _vm.editModel.email,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editModel,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editModel.email"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "classEdit.class-notification-address-label"
                                                  ),
                                                  rules: [_vm.rules.emailRules],
                                                  hint: _vm.$t(
                                                    "classEdit.notification-email-hint"
                                                  ),
                                                  "persistent-hint": ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.editModel
                                                      .notificationEmail,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editModel,
                                                      "notificationEmail",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editModel.notificationEmail"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-card-text", [
                !_vm.valid
                  ? _c("div", [
                      _c("span", { staticClass: "validateError" }, [
                        _vm._v(_vm._s(_vm.$t("classEdit.validate-info")))
                      ])
                    ])
                  : _vm._e()
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "success" },
                      on: { click: _vm.validate }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.editModel
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "800px", persistent: "" },
              model: {
                value: _vm.lessonPlannerOpen,
                callback: function($$v) {
                  _vm.lessonPlannerOpen = $$v
                },
                expression: "lessonPlannerOpen"
              }
            },
            [
              _c("lesson-planner", {
                attrs: {
                  "module-selection":
                    _vm.editModel.content === "" ? [] : _vm.editModel.content
                },
                on: {
                  save: _vm.onLessonPlannerSave,
                  cancel: _vm.onLessonPlannerCancel
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.warnContentChange,
            callback: function($$v) {
              _vm.warnContentChange = $$v
            },
            expression: "warnContentChange"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.$t("classEdit.content-changed")))
              ]),
              _c("v-card-text", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("classEdit.content-changed-text"))
                  }
                })
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.confirmContentChange(false)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1" },
                      on: {
                        click: function($event) {
                          return _vm.confirmContentChange(true)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.continue")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }